import '../App.css';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { playlistList } from '../Components/PlaylistList';
import React from 'react';
import { NavigateBefore, NavigateNext, FirstPage, LastPage } from '@mui/icons-material';

function Home({ token }: { token: string }) {

  const [playlists, setPlaylists] = useState([]);
  const [totalNumberPlaylists, setTotalNumberPlaylists] = useState(0);

  const PLAYLISTS_REQUEST_LIMIT = 60;
  const [offset, setOffset] = useState(0);

  const NAVIGATION_BUTTON_FONT_SIZE = "100px"

  const fetchPlaylists = useCallback(async () => {
    const playlist_resp: any = await axios.get(`https://api.spotify.com/v1/me/playlists/`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        limit: PLAYLISTS_REQUEST_LIMIT,
        offset: offset
      }
    }).catch(function (error) {
      return // TODO: do more with failure state
    })
    if (playlist_resp !== undefined) {
      setPlaylists(playlist_resp.data.items)
      if (totalNumberPlaylists === 0) {
        setTotalNumberPlaylists(playlist_resp.data.total)
      }
    }
  }, [offset, token, totalNumberPlaylists])

  useEffect(() => {
    if (token !== "") {
      fetchPlaylists()
    } else {
      setPlaylists([])
    }
  }, [token, fetchPlaylists])

  useEffect(() => {
    fetchPlaylists()
  }, [offset, fetchPlaylists])

  const increaseOffset = () => {
    setOffset(offset + PLAYLISTS_REQUEST_LIMIT);
  }

  const decreaseOffset = () => {
    setOffset(offset - PLAYLISTS_REQUEST_LIMIT);
  }

  function increaseButton(clickable: boolean = true) {
    return (
      <NavigateNext fontSize="inherit" onClick={clickable ? increaseOffset : () => { }} className={clickable ? "Playlist-nav-button-clickable" : "Playlist-nav-button-unclickable"} />
    )
  }

  function firstPageButton(clickable: boolean = true) {
    return (
      <FirstPage fontSize="inherit" onClick={clickable ? () => { setOffset(0) } : () => { }} className={clickable ? "Playlist-nav-button-clickable" : "Playlist-nav-button-unclickable"} />
    )
  }

  function lastPageButton(clickable: boolean = true, numberPlaylists: number) {
    return (
      <LastPage fontSize="inherit" onClick={clickable ? () => { setOffset(PLAYLISTS_REQUEST_LIMIT * Math.floor(numberPlaylists / PLAYLISTS_REQUEST_LIMIT)) } : () => { }} className={clickable ? "Playlist-nav-button-clickable" : "Playlist-nav-button-unclickable"} />
    )
  }

  function decreaseButton(clickable: boolean = true) {
    return (
      <NavigateBefore fontSize="inherit" onClick={clickable ? decreaseOffset : () => { }} className={clickable ? "Playlist-nav-button-clickable" : "Playlist-nav-button-unclickable"} />
    )
  }

  // TODO: style so these are bigger!
  function navButtons() {
    if (playlists === undefined || playlists === null || playlists.length === 0) {
      return <>
      </>
    }
    return (
      <div style={{ fontSize: NAVIGATION_BUTTON_FONT_SIZE, flexDirection: "row", minWidth: "502px" }}>
        {firstPageButton(offset!==0)}
        {decreaseButton(offset !== 0)}
        <span className="Playlist-offsets-text">
          {`${offset + 1} - ${Math.min(totalNumberPlaylists, offset + PLAYLISTS_REQUEST_LIMIT)}`}
        </span>
        {increaseButton((totalNumberPlaylists - PLAYLISTS_REQUEST_LIMIT > offset))}
        {lastPageButton((totalNumberPlaylists - PLAYLISTS_REQUEST_LIMIT > offset), totalNumberPlaylists)}

      </div>
    )
  }

  return (
    <div className="App">
      <div className="Playlist-body">
        {navButtons()}
        {playlistList(playlists)}
        {navButtons()}
      </div>

    </div>
  );
}

export default Home;
